var React = require('react');

function MailFill (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1038.5 166.1 540 623 41.5 166.1h997Z","opacity":".2","style":{"isolation":"isolate"},"key":0}),React.createElement("path",{"fill":"#d7d3d1","d":"M1038.5 124.6h-997C18.6 124.6 0 143.2 0 166.2v706.3c0 45.9 37.2 83.1 83.1 83.1H997c45.9 0 83.1-37.2 83.1-83.1V166.1c0-22.9-18.6-41.6-41.6-41.6h.1ZM540 566.7l-391.7-359h783.3l-391.7 359ZM387.9 540 83 819.4V260.6L387.9 540Zm61.5 56.4 62.3 57.4c15.9 14.5 40.2 14.5 56.1 0l62.3-57.4 301.2 276h-783l301.1-276ZM692.1 540 997 260.5v558.9L692.1 539.9Z","key":1})]);
}

MailFill.defaultProps = {"viewBox":"0 0 1080 1080"};

module.exports = MailFill;

MailFill.default = MailFill;
